import { SubjectTypeModel } from './subjectTypeModel';

export class AddSubjectTypeModel extends SubjectTypeModel {
}
